import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import { slugify } from "../../utils/index";

const Nav = ({ sticky, isHomePage }) => {
  const location = useLocation();

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      // Optional: Scroll smoothly to top if you want that behavior
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        <li className="menu-item-has-children">
          <Link
            to={process.env.PUBLIC_URL + "/"}
            onClick={handleHomeClick}
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Home
          </Link>
        </li>

        <li className="menu-item-has-children">
          <Link
            to={process.env.PUBLIC_URL + "/who-we-are"}
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            About Us <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            <li>
              <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                Who We Are
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/mission-vision"}>
                Mission & Vision
              </Link>
            </li>

            <li>
              <Link to={process.env.PUBLIC_URL + "/testimonials"}>
                Testimonials
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/health-safety"}>
                Health & Safety
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/sustainability"}>
                Sustainability
              </Link>
            </li>
            <li className="menu-item-has-children">
              <Link to="/smart-tech">
                Smart Tech
                {/* <FaAngleRight /> */}
              </Link>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <Link
            to="/services"
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Services <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            <li className="menu-item-has-children">
              <Link
                to="/service/ifm-services"
                style={{
                  color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
                }}
              >
                IFM Services
              </Link>
            </li>
            <li className="menu-item-has-children">
              <Link to="/service/hard-services">
                Hard Services
                {/* <FaAngleRight /> */}
              </Link>
            </li>
            <li className="menu-item-has-children">
              <Link
                to="/service/soft-services"
                // style={{
                //   color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
                // }}
              >
                Soft Services
                {/* <FaAngleRight /> */}
              </Link>
            </li>
            <li
              className="menu-item-has-children"
              // style={{
              //   color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
              // }}
            >
              <Link to="/service/security-services">
                Security Services
                {/* <FaAngleRight /> */}
              </Link>
            </li>
            <li className="menu-item-has-children">
              <Link
                to="/service/specialized-services"
                // style={{
                //   color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
                // }}
              >
                Specialized Services
                {/* <FaAngleRight /> */}
              </Link>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <Link
            to="/industry"
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Industries We Serve
            {/* <FaAngleDown /> */}
          </Link>
        </li>
        <li className="menu-item-has-children">
          <Link
            to={process.env.PUBLIC_URL + "/client-portfolio"}
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Client Portfolio
          </Link>
        </li>
        <li className="menu-item-has-children">
          <Link
            to="/accreditations"
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Accreditations
            {/* <FaAngleDown /> */}
          </Link>
        </li>

        <li className="menu-item-has-children">
          <Link
            to={process.env.PUBLIC_URL + "/contact-us"}
            style={{
              color: !isHomePage ? "#27272e" : sticky ? "#27272e" : "",
            }}
          >
            Contact Us <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            <li>
              <Link to={process.env.PUBLIC_URL + "/contact-us"}>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/request-quote"}>
                Request a Quote
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/faqs"}>FAQs</Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/careers"}>Careers</Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/cookie-policy"}>
                Cookie Policy
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
